<template>
  <div class="order-infor-comp">
    <div class="order-flex-left" :style="{width: leftWidth}">
      <el-divider/>
      <div class="order-infor-descriptions">
        <el-descriptions
            :column="1"
            border
            size="medium"
            style="margin-top: 20px;"
            :label-style="{width: '110px', 'text-align': 'right'}">
          <el-descriptions-item label="客户代码：">{{formData.customerNo}}</el-descriptions-item>
          <el-descriptions-item label="程序标信息：">{{formData.processInfo}}</el-descriptions-item>
          <el-descriptions-item label="防护处理：">{{formData.protection}}</el-descriptions-item>
          <el-descriptions-item label="配件包：">{{formData.peiJianPack}}</el-descriptions-item>
          <el-descriptions-item label="生产程序：">{{formData.productProcess}}</el-descriptions-item>
          <el-descriptions-item label="发货程序：">{{formData.deliveryProcess}}</el-descriptions-item>
          <el-descriptions-item label="其它1：">{{formData.note1}}</el-descriptions-item>
          <el-descriptions-item label="其它2：">{{formData.note2}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="order-flex-right">
      <el-divider/>
      <div class="order-infor-pdf">
        <el-table
            v-if="scanKey === 'PackScan'"
            :data="formData.bomPackMaterials"
            style="width: 100%;font-size: 20px;font-weight: bold"
            height="100%"
            border
        >
          <el-table-column label="物料描述" prop="maktx2" min-width="200"/>
          <el-table-column label="物料号" prop="idnrk" width="150"/>
          <el-table-column label="数量" prop="menge" width="80"/>
          <el-table-column label="照片" prop="center" min-width="80">
            <template slot-scope="scope">
              <el-image
                  style="width: 30px; height: 30px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  const ossUrl = ".oss-cn-shanghai.aliyuncs.com";
  export default {
    name: "OrderInforComp",
    props: {
      leftWidth: {
        type: String,
        default: "550px",
      },
      scanKey: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        imgUrls: [],
        formData: {
          orders: "", // 订单号
          customerNo: "--", // 客户代码
          processInfo: "--", // 程序标信息
          protection: "--", // 防护处理
          peiJianPack: "--", // 配件包
          productProcess: "--", // 生产程序
          deliveryProcess: "--", // 发货程序
          note1: "--",
          note2: "--",
          bomPackMaterials: [], // 包装物料
        },
      };
    },
    methods: {
      // 获取订单信息
      getData(orderNo) {
        this.loading = true;
        if(!orderNo || this.formData.orders === orderNo) {
          return;
        }
        this.$http.get("basic", `sapProductionOrders/getOrderByNo/${orderNo}`).then((res) => {
          const {success, data} = res;
          if(success) {
            this.formData = data;
            this.formData.bomPackMaterials.forEach(row=>{
              if (row.filePath !== null) {
                if(row.filePath.includes(ossUrl)) {
                  row.imgUrl=row.filePath;
                  this.imgUrls.push(row.imgUrl);
                }else{
                  this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                    if (res.success) {
                      row.imgUrl = res.data;
                      this.imgUrls.push(row.imgUrl);
                    }
                  });
                }
              }
            });
          }
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script> 
<style scoped lang="scss">
.order-flex-right {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #ddd;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-width: 600px;
  display: flex;
  flex-direction: column;
}
.order-infor-pdf{
  flex: 1;
  overflow: auto;
  // ::v-deep .el-table .cell{
  //   line-height: 43px;
  //   font-size: 15px;
  //   font-weight: bold;
  // }
}
.order-flex-left{
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.order-infor-descriptions{
  overflow: auto;
  flex: 1;
  ::v-deep .el-descriptions--medium.is-bordered .el-descriptions-item__cell{
    padding: 5px;
  }
}

.order-infor-comp {
  padding: 0 ;
  display: flex;
  height: calc(50vh - 85px);
  overflow-x: auto;
}
.el-divider--horizontal{
  margin: 20px 0 5px;
}
::v-deep .el-descriptions-item__label.is-bordered-label{
  background: #b8b9b9;
    color: #333;
}
</style>
